module.exports = __webpack_public_path__ + "img/warning.2eef6e0e.svg";